import { Box, Tooltip, Typography } from "@mui/material"
import { type FC } from "react"

import { useVersion } from "./useAppVersion"

const NO_TAG = "no-tag"

const VersionTag: FC = () => {
  const { version } = useVersion()

  if (!version) {
    return null
  }

  return (
    <Tooltip
      title={
        <Box>
          Deployed: {version.deployDate}
          <br />
          Commit: {version.commitDate}
        </Box>
      }
    >
      <Box className='flex items-center space-x-1'>
        <Typography variant='caption' color='textDisabled'>
          ver. {version.tag === NO_TAG ? version.shortHash : version.tag}
        </Typography>
      </Box>
    </Tooltip>
  )
}

export default VersionTag
